import Vue from "vue";
import VueI18n from "vue-i18n";
import iviewEn from "view-design/dist/locale/en-US";
import iviewZh from "view-design/dist/locale/zh-CN";
import enLocale from "./en";
import zhLocale from "./zh";

Vue.use(VueI18n);

const messages = {
  en: {
    ...enLocale,
    ...iviewEn,
  },
  zh: {
    ...zhLocale,
    ...iviewZh,
  },
};

export function getLanguage() {
  const chooseLanguage = sessionStorage.getItem("language");
  if (chooseLanguage) {
    return chooseLanguage;
  }

  // 获取浏览器 language
  const language = (navigator.language || navigator.browserLanguage).toLowerCase();
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.includes(locale)) {
      return locale;
    }
  }
  return "en";
}
const i18n = new VueI18n({
  // 设置 locale
  locale: getLanguage(),
  // 设置 locale messages
  messages,
});

export default i18n;
